import { KeyValue } from "../models/KeyValue";

export const isObjectsEqual = (obj1: Object, obj2: Object) => {
	return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const removeUndefined = (obj: any): any => {
	return Object.keys(obj).forEach(
		(key) =>
			(obj[key] === undefined || obj[key] === "" || !Object.keys(obj[key]).length) &&
			delete obj[key]
	);
};

export const enumToKeyValueArray = (enumValues: { [key: string]: string }): KeyValue[] => {
	return Object.keys(enumValues).map((key) => ({ key, value: enumValues[key] as string }));
};

export const isEmpty = (obj: any) => {
	return Object.keys(obj).length === 0;
};

export function isUndefinedOrTrue(val?: boolean) {
	return !!val || typeof val === "undefined";
}

export const getNumberValue = (val?: number): number => {
	return val ?? 0;
};
